var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"lg:text-lg bg-blue-700 text-white lg:px-4 lg:py-2 text-sm rounded-full lg:mt-2 p-2",attrs:{"onclick":_vm.url,"href":"#","download":_vm.fileName}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }